import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { CommentValue } from '@app/models';
import { LoginService } from '@app/services';
import { AppCommentsService } from '@app/services/app-comments.service';
import { map } from 'rxjs';

/**
 * This component should not show for Software Only users or Vendors.
 * For QBAT users - This will show:
 *   A readonly of all the QBAT notes in the summary section
 *   A readonly of the notes taken by the Agencies in the summary section.
 * For FS Agency Users - this will show:
 *   A readonly of all the QBAT notes in the summary section.
 */
@Component({
  selector: 'qb-app-comments-summary',
  templateUrl: './app-comments-summary.component.html',
  styleUrls: ['./app-comments-summary.component.scss'],
  imports: [],
})
export class AppCommentsSummaryComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  contractorComments: CommentValue[] = [];
  agencyNotes: CommentValue[] = [];

  isQbat = false;
  /** If we are a qbat user, we want to see the text that the agency users have saved in their notes textarea in the summary section. */
  notesFromFSAgency: string;

  constructor(
    private loginService: LoginService,
    private appComments: AppCommentsService
  ) {}

  ngOnInit(): void {
    this.isQbat = this.loginService.isQbat;
    if (this.isQbat) {
      // This doesn't need to be an observable because it won't change after this component is loaded.
      this.notesFromFSAgency = this.appComments.agencyUserCommentGroup?.value.agencyNotes;
    }

    this.appComments.comments.valueChanges
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(() => {
          const controls = { ...this.appComments.comments.controls };
          delete controls[this.appComments.agencyUserCommentName];
          delete controls[this.appComments.colbiInternalNotesName];

          return Object.keys(controls).map(key => {
            return (controls[key] as FormGroup).getRawValue() as CommentValue;
          });
        }),
        map(comments => this.appComments.sortComments(comments))
      )
      .subscribe(comments => {
        // I hate that I had to do this instead of using the async pipe, but it was absolutely not working and being dumb.
        this.contractorComments = comments.reduce((arr, curr) => {
          if (curr.contractorComments) {
            arr.push(curr);
          }
          return arr;
        }, []);
        this.agencyNotes = comments.reduce((arr, curr) => {
          if (curr.agencyNotes) {
            arr.push(curr);
          }
          return arr;
        }, []);
      });

    this.appComments.comments.updateValueAndValidity();
  }
}
